import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { ListingNewsDocument, ListingNewsNode, PaginaDocument, PaginaNode } from '@gql/graphql'
import BlogListing from '@components/organisms/BlogListing/BlogListing'

interface Props {
  pagina?: PaginaNode
  listing?: ListingNewsNode
  isCatalogo?: boolean
}

const BlogCategoryListing = ({ pagina, listing, isCatalogo }: Props) => {
  return <BlogListing {...{ pagina, listing, isCatalogo }} key={listing.categoria.pk} buttonUrl />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/idee-verdi/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const keys = ['p']
    const extractedParams = {}

    if (slug) {
      const paramsArray = [...slug]

      keys.forEach((key) => {
        const keyIndex = paramsArray.indexOf(key)
        if (keyIndex !== -1 && keyIndex < paramsArray.length - 1) {
          extractedParams[key] = paramsArray[keyIndex + 1]
          paramsArray.splice(keyIndex, 2)
        }
      })

      slug = paramsArray
    }

    const {
      data: { listingNews },
    } = await client.query({
      query: ListingNewsDocument,
      variables: {
        slug: slug[0],
        params: extractedParams,
      },
      context: {
        headers,
      },
    })

    if (
      !listingNews ||
      !listingNews?.news ||
      listingNews?.news?.length == 0 ||
      !listingNews?.categoria?.pagina
    ) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: {
          ...listingNews.categoria.pagina,
          titolo: listingNews.categoria.nome,
          descrizione: listingNews.categoria.isCatalogo
            ? listingNews.categoria.pagina.descrizione
            : null,
          nome: listingNews.categoria.nome,
          mainImage: listingNews.categoria.isCatalogo
            ? null
            : listingNews.categoria.pagina.mainImage,
          seo: {
            ...listingNews.categoria.pagina.seo,
            canonicalUrl: listingNews.canonicalUrl,
          },
        },
        listing: listingNews,
        isCatalogo: listingNews.categoria.isCatalogo,
      },
      revalidate: 60 * 20,
    }
  },
  '/idee-verdi/c/[slug]'
)

export default BlogCategoryListing
